import { gql } from "@apollo/client";

export const GET_USER_BY_CREDENTIALS = gql`
query QLogin($usuario: String!, $clave: String!, $token: String!, $ipUsuario: String!, $pcUsuario: String!, $longitud: String!, $latitud: String!){
    login (
        request: {
            usuario: $usuario,
            password: $clave,
            token: $token,
            ipUsuario: $ipUsuario,
            pcUsuario: $pcUsuario,
            longitud: $longitud,
            latitud: $latitud
        }) {
        success,
        error,
        valorEsperado {
            valido,
            token,
            tokenValidTo,
            usuario {
                idUsuario              
            }
        }
    }
}`;